module.exports = __webpack_public_path__ + "static/media/suv_tomato.15dddf51.svg";